//chart
import Histogram from "assets/images/chart-images/histogram.png";

const numberOfUniqueReviewersInvited = [
    // Time from editor assignment to first reviewer invited-none
    { id: "#E#UI-H01e", name: "histogram", chartImage: Histogram, disabled: false },
    { id: "#E#UI-H01s", name: "histogram", chartImage: Histogram, disabled: false },
    
];

export default numberOfUniqueReviewersInvited;
